import { animated, useSpring } from "@react-spring/web";

import styles from "./Answer.module.css";

export const AnswerLoading = () => {
    const animatedStyles = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 }
    });

    return (
        <animated.div style={{ ...animatedStyles }}>
            <div className={styles.answerContainer}>
                <div className={styles.typingIndicator}>
                    <span />
                    <span />
                    <span />
                </div>
            </div>
        </animated.div>
    );
};
